import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, Button } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { deleteCalendarEntry, getCalendarEntry } from './calendarEntry.reducer';

export const CalendarEntryDeleteModal = (
  props: RouteComponentProps<{ id: string; ecoleid: string; classeid: string; anneeScolaireId: string }>
) => {
  const dispatch = useAppDispatch();
  const calendarEntry = useAppSelector(state => state.calendarEntry.entity);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const ecoleid = props.match.params.ecoleid;
  const classeid = props.match.params.classeid;
  const anneeScolaireId = props.match.params.anneeScolaireId;

  useEffect(() => {
    dispatch(getCalendarEntry(props.match.params.id));
  }, []);

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/calendar/${ecoleid}/${anneeScolaireId}/${classeid}/calendarEntry`);
  };

  const onDelete = () => {
    const entity = {
      id: props.match.params.id,
      classeId: props.match.params.classeid,
      anneeScolaireId: props.match.params.anneeScolaireId,
    };
    dispatch(deleteCalendarEntry(entity));
    handleClose(event);
  };
  const goBack = () => {
    props.history.goBack();
  };

  return (
    <>
      {calendarEntry.id !== null && (
        <Modal
          title="Confirmation de supression"
          centered
          footer={[
            <Button key="back" onClick={goBack}>
              Annuler
            </Button>,
            <Button key="submit" style={{ backgroundColor: '#cd201f', color: 'white' }} onClick={e => onDelete()}>
              supprimer
            </Button>,
          ]}
          visible={true}
          closable={false}
        >
          Cet action supprimera également toutes les données liées à ce cours. Etes-vous certain de vouloir continuer ?
        </Modal>
      )}
    </>
  );
};

export default CalendarEntryDeleteModal;
